import { useFormContext } from "@/context/form";
import { useEffect } from "react";

const useFormListener = (
  formId: string,
  isDirty: boolean,
  isSubmitting: boolean
) => {
  const { setId, setDirty, setSubmitting, reset } = useFormContext();

  useEffect(() => {
    setDirty(isDirty);
    setSubmitting(isSubmitting);
  }, [isDirty, isSubmitting]);

  useEffect(() => {
    setId(formId);

    return reset;
  }, []);
};

export { useFormListener };
